module.exports = __webpack_public_path__ + "static/media/image3.8f55f7ff.png";